import React, { useEffect, useMemo, useState } from "react";
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Modal, Button } from "antd";
import {
  Row,
  Col,
  Card,
  Checkbox,
  Input,
  Select,
  Skeleton,
  Typography,
  Radio,
  Tag,
  Collapse,
  Spin,
} from 'antd';
import HttpRequest from "../../../../utils/HttpRequest";
import { GeneInfo } from '../../components/GenaScreen/ResultFound/ResultFound'
// import './ViewCase.css'
import { useHistory } from 'react-router-dom';
import DeleteCase from "../DeleteCaseV2/DeleteCase";
import CaseHistoryModal from "../CaseHistoryV2/CaseHistory";
import SymptomsQueryTags from "../GenaScreen/SymptomsQueryTags/SymptomsQueryTags";
import moment from "moment";
import CustomIcon from "../../../../utils/components/CustomIcon/CustomIcon";

const { Title } = Typography

const CaseDetailsModal = ({ isModalOpen, setIsModalOpen, caseDetails }) => {
  const history = useHistory()
  const [masterCase, setMasterCase] = useState(null)
  const [genes, setGenes] = useState(null)
  const [totalGenes, setTotalGenes] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showDeleteCaseModal, setShowDeleteCaseModal] = useState(false)
  const [showCaseHistoryModal, setShowCaseHistoryModal] = useState(false)

  const latestCaseVersion = useMemo(() => {
    if (!caseDetails) return
    const sortedResult = caseDetails.CaseVersions?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    return sortedResult[0]
  }, [caseDetails])

  const fetchMasterCase = async (masterCaseId) => {
    try {
      const res = await new HttpRequest(null, `/cases/${masterCaseId}`, 'get', {}).send()
      const masterCaseObj = res.data.data
      setMasterCase(masterCaseObj)
    } catch (err) {
      setError(err)
    }
  }

  useEffect(() => {
    if (!caseDetails) return
    fetchMasterCase(caseDetails.masterCaseId)
  }, [caseDetails])

  useEffect(() => {
    if (!latestCaseVersion) return

    setLoading(true)
    setGenes(null)
    setTotalGenes(0)

    const fetchData = async () => {
      try {
        const { query, geneFilter, clinicalFeatures } = latestCaseVersion.SearchHistory

        let queryString = '?caseVersionId=' + latestCaseVersion.id
        if (geneFilter === 'withDisorders') {
          queryString += "&withDisorders=true"
        } else if (geneFilter === 'dominant') {
          queryString += "&dominant=true"
        } else if (geneFilter === 'recessive') {
          queryString += "&recessive=true"
        } else if (geneFilter === 'x-linked') {
          queryString += "&x-linked=true"
        } else {
          queryString += "&withDisorders=true"
        }

        if (clinicalFeatures)
          queryString += "&clinicalFeatureSearchStr=" + clinicalFeatures;

        queryString += "&hpoQueryStr=" + query;
        queryString += "&start=" + 0;
        queryString += "&rows=" + 100000;

        const res = await new HttpRequest(null, `/genes${queryString}`, 'get', {}).send()
        const { docs, numFound } = res.data.data.response
        setGenes(docs)
        setTotalGenes(numFound)
      } catch (error) {
        setError(error.message)
      } finally {
        setLoading(false)
      }
    };
    fetchData()
  }, [latestCaseVersion])

  const handleCancel = () => {
    setIsModalOpen(false); // Close modal
  };

  const handleResumeSearch = () => {
    // navigate to screen home page
    history.push(`/search?searchRecordId=${latestCaseVersion?.SearchHistory?.id}`)
  }

  const handleDeleteCase = () => {
    // open delete case modal
    setShowDeleteCaseModal(true)
  }

  const onCaseDelete = () => {
    setShowDeleteCaseModal(false)
    setTimeout(() => {
      setIsModalOpen(false); // Close modal
    }, 300)
  }

  const handleViewHistory = () => {
    // open delete case modal
    setShowCaseHistoryModal(true)
  }

  const handleRequestTest = () => {
    // navigate to request test page
    history.push(`/request-test?caseVersionId=${latestCaseVersion?.id}`)
  }

  const TagsComponent = useMemo(() => {
    if (!latestCaseVersion || !caseDetails) return null

    const caseTitle = caseDetails.nickName
    const { queryJSON, ethnicity, age, gender } = latestCaseVersion.SearchHistory || {}

    return (
      <div className="flex-vertical-gap-2">
        <Typography.Text style={{ margin: 0 }} type="secondary">Saved: {moment(latestCaseVersion.createdAt).local().format('DD/MM/YYYY HH:mm:ss')}</Typography.Text>
        <Title level={3} style={{ margin: 0 }}>{caseTitle}</Title>
        <div className="custom-tag-container">
          <Tag className="custom-tag">{ethnicity}</Tag>
          <Tag className="custom-tag">{age}</Tag>
          <Tag className="custom-tag">{gender}</Tag>
        </div>
        <SymptomsQueryTags node={queryJSON} />
      </div>
    )
  }, [caseDetails, latestCaseVersion])

  return (
    (<Modal
      title={
        <div className="flex-vertical-gap-4">
          <div className="flex-horizontal-gap-4">
            <CustomIcon name="OpenFolder" width={40} height={40} />
            <Typography.Title level={2} style={{ margin: 0 }}>Case Details</Typography.Title>
          </div>
          <Button type="primary" block onClick={handleRequestTest}>
            Request Test
            <CustomIcon name="Mail" />
          </Button>
        </div>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '60vh',
        overflowY: 'auto'
      }}
    >
      <div className="flex-vertical-gap-4">
        {TagsComponent}
        <div className="flex-vertical-gap-2">
          <Button style={{ background: 'transparent' }} block onClick={handleResumeSearch}>
            Resume Search
            <CustomIcon name="Search" />
          </Button>
          <Button style={{ background: 'transparent' }} block onClick={handleViewHistory}>
            View History
            <CustomIcon name="History" />
          </Button>
          <Button style={{ background: 'transparent' }} block onClick={handleDeleteCase}>
            Delete Case
            <CustomIcon name="DeleteTrash" />
          </Button>
        </div>
        {loading ? <Skeleton /> : (Array.isArray(genes) && <GeneInfo total={totalGenes} genes={genes} />)}
      </div>
      <DeleteCase isModalOpen={showDeleteCaseModal} setIsModalOpen={setShowDeleteCaseModal} onDelete={onCaseDelete} caseDetails={caseDetails} />
      <CaseHistoryModal isModalOpen={showCaseHistoryModal} setIsModalOpen={setShowCaseHistoryModal} caseDetails={caseDetails} />
    </Modal>)
  );
};

export default CaseDetailsModal;
